<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" class="hero--wrap pt-10 px-4">
          <v-row wrap>
            <v-col cols="12" lg="9" xl="6" class="mx-auto">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="6"
                  lg="6"
                  xl="5"
                  class="mx-auto ml-sm-auto"
                >
                  <div class="mb-5 mb-md-10">
                    <h2 class="display-3 font-weight-black mt-12"
                      >Online Ordering for Growing Food Businesses.</h2
                    >
                    <div class="display-1 my-6 hidden-xs-only">
                      Minimart handles your website, menus, online ordering,
                      customers, and much more.
                    </div>
                  </div>
                  <div class="text-center">
                    <transition name="fade-in-left" appear>
                      <div>
                        <v-btn
                          v-if="play"
                          dark
                          depressed
                          rounded
                          class="my-2 v-size--jumbo font-weight-bold"
                          color="blue darken-1"
                          to="/signup"
                          >{{
                            $mq === 'xs'
                              ? 'Start Free Trial'
                              : 'Start My Free Trial'
                          }}</v-btn
                        >
                        <div>
                          No credit card required, free 30-day trial.
                        </div>
                      </div>
                    </transition>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  xl="7"
                  :class="[
                    'mx-auto pa-0 pa-sm-auto mt-5 mt-md-10 mr-md-n10 align-self-center',
                    { hiddenImg: !collageLoaded },
                  ]"
                >
                  <v-img
                    :src="collageSrc"
                    class="collage--img"
                    @load="collageLoaded = true"
                  />
                </v-col>
                <v-col cols="12" sm="10" class="d-sm-none mx-auto">
                  <div class="display-1 my-6">
                    Minimart handles your website, menus, online ordering,
                    customers, and much more.
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="mx-n4">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100">
          <path
            fill="#ffe69a"
            fill-opacity="1"
            d="m719.99999,98.5c-469.70535,0 -850.16668,-64.55849 -850.16668,-144.26034c0,-79.70184 380.46133,-144.26034 850.16668,-144.26034c469.70535,0 850.16668,64.55849 850.16668,144.26034c0,79.70184 -380.46133,144.26034 -850.16668,144.26034z"
          ></path>
        </svg>
      </div>
      <v-row>
        <v-col cols="12" sm="10" md="9" lg="7" class="mx-auto mt-10">
          <v-row wrap>
            <v-col col="12" lg="12" xl="" class="mx-auto">
              <v-row
                wrap
                :class="['text-center', $mq === 'xs' ? 'mx-0' : 'mx-6']"
                justify="center"
              >
                <v-col cols="12" sm="10" md="10" class="text-center">
                  <h1 class="display-2 font-weight-bold mb-3"
                    >The Fastest Way to Start Taking Orders</h1
                  >
                </v-col>
                <v-col
                  cols="12"
                  sm="10"
                  md="6"
                  class="px-0 px-sm-10 px-md-10 py-6"
                  align-self="center"
                >
                  <div class="headline mb-4">
                    Minimart was started by food industry insiders with over a
                    decade of software and design experience.
                  </div>
                  <v-btn
                    to="/how-it-works"
                    dark
                    large
                    outlined
                    color="blue darken-1"
                    >Tour the Features</v-btn
                  >
                </v-col>
                <v-col
                  cols="12"
                  sm="10"
                  md="6"
                  class="px-0 px-sm-10 px-md-10 py-6"
                  align-self="center"
                >
                  <div class="headline mb-4">
                    From bagels to chili oil, burgers to fresh roasted coffee,
                    we power food makers of all styles across the U.S.
                  </div>
                  <v-btn
                    to="/minimart-community"
                    dark
                    large
                    outlined
                    color="blue darken-1"
                    >Meet Our Community</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="my-10"></v-divider>
        </v-col>
        <v-col cols="12" lg="12" class="mx-auto">
          <v-row align-content="center" justify="center">
            <v-col cols="12" lg="10" xl="7">
              <PersonaSections />
            </v-col>

            <v-col cols="12" class="text-center py-10">
              <v-btn
                x-large
                dark
                depressed
                class="ma-2"
                color="blue darken-1"
                to="/signup"
                >{{
                  $mq !== 'xs' ? 'Start Selling With Minimart' : 'Get Started'
                }}</v-btn
              >
              <v-btn
                :x-large="!['xs', 'sm'].includes($mq)"
                dark
                outlined
                class="ma-2"
                color="blue darken-1"
                to="/how-it-works"
                >More About Minimart</v-btn
              >
            </v-col>
            <v-col cols="12" sm="9" md="8" lg="6">
              <div class="headline text-center font-italic my-6">
                Supporting and uplifting the independent food community is, and
                will always be, a core mission of our platform.
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import PersonaSections from '@/components/PersonaSections'

export default {
  name: 'HomeView',
  components: { PersonaSections },
  computed: {
    collageSrc() {
      const src = this.$vuetify.breakpoint.smAndDown
        ? `https://res.cloudinary.com/resto/image/upload/q_75/v1634833292/minimart/Homepage_Collage_-_Mobile.png`
        : `https://res.cloudinary.com/resto/image/upload/f_auto,q_75/v1634832140/minimart/homepage_collage-desktop.png`
      return src
    }, // collageSrc
  },
  data() {
    return {
      play: true,
      collageLoaded: false,
    }
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.hero--wrap {
  background-color: #ffe69a;
}

.about-text {
  color: rgb(30, 30, 30);
  font-family: $body-font-family;
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: opacity 1s, transform 1s ease-in-out;
}
.fade-up-enter, .fade-up-leave-to /* .fade-up-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30%);
}

.fade-in-left-enter-active,
.fade-in-left-leave-active {
  transition: opacity 1.2s, transform 1.2s ease-in-out;
}
.fade-in-left-enter, .fade-in-left-leave-to /* .fade-in-left-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-20px);
}

.collage--img {
  transition: opacity 1.4s, transform 1.4s ease-in-out;
}
.hiddenImg {
  .collage--img {
    opacity: 0;
    transform: translateY(20px);
  }
}
</style>
